import { css } from '@emotion/react';

/* Outlined, not filled: a count that changed is information, not an alarm. Shared by the settings
   page's impact strip and the preview's stat row so the two read as the same control. */
export const pillCss = css`
  display: inline-flex;
  align-items: center;
  border: 1px solid var(--mui-colors-border-card);
  border-radius: 20px;
  padding: 3px 10px;
  font-size: 11px;
  font-variant-numeric: tabular-nums;
  color: var(--mui-colors-text-secondary);
  white-space: nowrap;
`;

/* Amber on the text, not a filled block. */
export const pillWarnCss = css`
  color: #9a5b00;
  border-color: currentColor;
`;
